import React from 'react';
import { Box, Spinner } from '@amzn/awsui-components-core';

export const LoadingSpinner = () => {
  return (
    <Box data-testid="loading-spinner" margin="xxl" padding="xxl" textAlign="center">
      <Spinner size="large" />
    </Box>
  );
};
